function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.043,55.931a3.572,3.572,0,0,1-1.029-2.84l1.35-14.87A7.05,7.05,0,0,1,3.4,33.892L35.445,1.809a7.036,7.036,0,0,1,9.677.247l9.754,9.763,0,0a6.875,6.875,0,0,1,.244,9.68L23.068,53.585a7.018,7.018,0,0,1-4.326,2.025L3.887,56.965c-.106.01-.215.013-.324.013A3.567,3.567,0,0,1,1.043,55.931Z",
  transform: "translate(0 0)",
  fill: "#2171ea"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.043,55.931a3.572,3.572,0,0,1-1.029-2.84l1.35-14.87A7.05,7.05,0,0,1,3.4,33.892L35.445,1.809a7.036,7.036,0,0,1,9.677.247l9.754,9.763,0,0a6.875,6.875,0,0,1,.244,9.68L23.068,53.585a7.018,7.018,0,0,1-4.326,2.025L3.887,56.965c-.106.01-.215.013-.324.013A3.567,3.567,0,0,1,1.043,55.931Z",
  transform: "translate(0 0)",
  fill: "#2171ea"
}));

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.999,
    height: 56.978,
    viewBox: "0 0 56.999 56.978",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.f4a41565.svg";
export { ForwardRef as ReactComponent };